import { addDays, differenceInCalendarDays, subDays } from "date-fns"

export const averageCycleLength = 28

export default function calculateDueDateResult(
    radioValue: string,
    dateChoosen: Date,
    cycleLength: number
) {
    const pregnancyLengthInDays = 283
    const fertilityLengthInDays = 14

    let dueDate: Date
    let likelyFertilizationDate: Date
    let totalDaysIntoPregnancy: number
    let totalDaysLeftInPregnancy: number
    if (radioValue === "lastMenstration") {
        dueDate = addDays(dateChoosen, pregnancyLengthInDays)

        likelyFertilizationDate = addDays(dateChoosen, fertilityLengthInDays)
        if (cycleLength > averageCycleLength)
            // for hver dag over 28 dager i syklusen legges det til en dag i fertilitetsperioden
            likelyFertilizationDate = addDays(
                dateChoosen,
                fertilityLengthInDays + (cycleLength - averageCycleLength)
            )

        if (cycleLength < averageCycleLength)
            // for hver dag under 28 dager i syklusen trekkes det fra en dag i fertilitetsperioden
            likelyFertilizationDate = addDays(
                dateChoosen,
                fertilityLengthInDays - (averageCycleLength - cycleLength)
            )

        totalDaysIntoPregnancy = differenceInCalendarDays(
            new Date(),
            likelyFertilizationDate
        )
        totalDaysLeftInPregnancy = differenceInCalendarDays(dueDate, new Date())
        return {
            dueDate,
            totalDaysIntoPregnancy,
            totalDaysLeftInPregnancy,
            likelyFertilizationDate
        }
    } else if (radioValue === "dueDate") {
        dueDate = dateChoosen
        likelyFertilizationDate = subDays(
            dueDate,
            pregnancyLengthInDays - fertilityLengthInDays
        )
        totalDaysIntoPregnancy = differenceInCalendarDays(
            likelyFertilizationDate,
            dateChoosen
        )
        totalDaysLeftInPregnancy = differenceInCalendarDays(dueDate, new Date())
        return {
            dueDate,
            totalDaysIntoPregnancy,
            totalDaysLeftInPregnancy,
            likelyFertilizationDate
        }
    }
}

export function calculateTimeIntoPregnacy(totalDaysIntoPregnancy: number) {
    const amountWeeksIntoPregnancy = Math.floor(totalDaysIntoPregnancy / 7)
    const amountDaysIntoPregnancy =
        totalDaysIntoPregnancy - amountWeeksIntoPregnancy * 7

    if (amountWeeksIntoPregnancy < 0)
        return "Du har ikke blitt gravid enda, eller har passert termin"

    return `${amountWeeksIntoPregnancy} uker og ${amountDaysIntoPregnancy} dager`
}

export function calculateTimeLeftInPregnancy(totalDaysLeftInPregnancy: number) {
    totalDaysLeftInPregnancy
    const weeksLeftInPregnancy = Math.floor(totalDaysLeftInPregnancy / 7)
    const daysLeftInPregnancy =
        totalDaysLeftInPregnancy - weeksLeftInPregnancy * 7

    if (weeksLeftInPregnancy < 0)
        return "Du har ikke blitt gravid enda, eller har passert termin"

    return `${weeksLeftInPregnancy} uker og ${daysLeftInPregnancy} dager`
}

export function printResult() {
    const result = document.getElementById("result")?.outerHTML
    const w = window.open()
    if (w) {
        w.document.write(result ?? "")
        w.print()
        w.close()
    }
}
